module.exports = __webpack_public_path__ + "img/prev1.0251a79.png";